import React from 'react';
import PageLayout from '../components/PageLayout';
import Hero from '../components/Hero';
import CTASection from '../components/CTASection';
import useBrand from '../branding/useBrand';
import useDocumentTitle from '../hooks/useDocumentTitle';
import './Page.css';
import './HowItWorksPage.css';

function HowItWorksPage() {
  const content = useBrand().pages.howItWorks;
  useDocumentTitle(content.title);

  return (
    <PageLayout
      hero={(
        <Hero
          title={content.title}
          lead={content.heroLead}
        />
      )}
    >
      <div className="how-page">
        <section className="page-section how-intro">
          <span className="how-eyebrow">{content.introEyebrow}</span>
          <h2>{content.introTitle}</h2>
          <p>
            {content.introBody}
          </p>
        </section>

        <section className="page-section how-loop-section">
          <div className="how-loop">
            {content.operatingLoop.map((step) => (
              <article key={step.title} className="how-loop-step">
                <span className="how-loop-number">{step.number}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="page-section how-split-section">
          <div className="how-split-copy">
            <span className="how-eyebrow">{content.lifecycleEyebrow}</span>
            <h2>{content.lifecycleTitle}</h2>
            <p>
              {content.lifecycleBody}
            </p>
          </div>
          <div className="how-lifecycle">
            {content.lifecycle.map((step, index) => (
              <article key={step.title} className="how-lifecycle-step">
                <span>{String(index + 1).padStart(2, '0')}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="driver-flow" className="page-section how-driver-section">
          <header className="section-header">
            <span className="how-eyebrow">{content.driverEyebrow}</span>
            <h2 className="section-heading">{content.driverTitle}</h2>
            <p className="section-subhead">
              {content.driverBody}
            </p>
          </header>

          <div className="how-driver-flow">
            {content.driverJourney.map((step, index) => (
              <article key={step.title} className="how-driver-step">
                <span className="how-driver-node">{String(index + 1).padStart(2, '0')}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="page-section how-outcome-section">
          <div>
            <span className="how-eyebrow">{content.outcomeEyebrow}</span>
            <h2>{content.outcomeTitle}</h2>
          </div>
          <div className="how-outcome-grid">
            {content.outcomes.map((outcome) => (
              <article key={outcome.title}>
                <h3>{outcome.title}</h3>
                <p>{outcome.description}</p>
              </article>
            ))}
          </div>
        </section>

        <CTASection />
      </div>
    </PageLayout>
  );
}

export default HowItWorksPage;
